const  router = [
	{
		path: "/project/layout",
		component: () => import('../../../pages/project/Layout.vue'),
		meta: {title: '卡包'},
		name: 'oncecardIndex',
		children:[
			/*{
				path: "/project",
				component: () => import('../../../pages/project/Index.vue'),
				meta: {title: '项目管理', type:'m', permission: 'projectIndex'},
				name: 'projectIndex'
			},
			{
				path: "/project/edit",
				component: () => import('../../../pages/project/EditProject.vue'),
				meta: {title: '编辑项目', type:'c', permission: 'project_index_edit'},
				name: 'project_index_edit'
			},
			{
				path: "/project/snapup",
				component: () => import('../../../pages/project/Snapup.vue'),
				meta: {title: '抢购管理', type:'c', permission: 'project_snapup'},
				name: 'project_snapup'
			},
			{
				path: "/project/snapup/edit",
				component: () => import('../../../pages/project/EditSnapup.vue'),
				meta: {title: '编辑抢购', type:'c', permission: 'project_snapup_edit'},
				name: 'project_snapup_edit'
			},*/
			{
				path: "/project/oncecard",
				component: () => import('../../../pages/project/Oncecard.vue'),
				meta: {title: '卡片管理', type:'c', permission: 'project_oncecard'},
				name: 'oncecardIndex', // 选中的效果
			},
			{
				path: "/project/oncecard/edit",
				component: () => import('../../../pages/project/EditOncecard.vue'),
				meta: {title: '编辑卡片', type:'c', permission: 'project_oncecard_edit'},
				name: 'project_oncecard_edit'
			},
			{
				path: "/card/orderRechargecard",
				component: () => import('../../../pages/card/OrderRechargeCard.vue'),
				meta: {title: '充值卡订单', type:'c', permission: 'card_order_rechargecard'},
				name: 'card_order_rechargecard'
			},
			{
				path: "/card/orderRechargecardDetail",
				component: () => import('../../../pages/card/OrderRechargeCardDetail.vue'),
				meta: {title: '充值卡订单详情', type:'c', permission: 'card_order_rechargecard_detail'},
				name: 'card_order_rechargecard_detail'
			},
			{
				path: "/project/orderOncecard",
				component: () => import('../../../pages/project/OrderOncecard.vue'),
				meta: {title: '诊疗卡订单', type:'c', permission: 'project_order_oncecard'},
				name: 'project_order_oncecard'
			},
			{
				path: "/project/orderOncecardDetail",
				component: () => import('../../../pages/project/OrderOncecardDetail.vue'),
				meta: {title: '诊疗卡订单详情', type:'c', permission: 'project_order_oncecard_detail'},
				name: 'project_order_oncecard_detail'
			},
			{
				path: "/card/orderActivitycard",
				component: () => import('../../../pages/card/OrderActivityCard.vue'),
				meta: {title: '活动卡订单', type:'c', permission: 'card_order_activity'},
				name: 'card_order_activity'
			},
			{
				path: "/card/orderActivitycardDetail",
				component: () => import('../../../pages/card/OrderActivityCardDetail.vue'),
				meta: {title: '活动卡订单详情', type:'c', permission: 'card_order_activity_detail'},
				name: 'card_order_activity_detail'
			},
			/*{
				path: "/project/orderSnapup",
				component: () => import('../../../pages/project/OrderSnapup.vue'),
				meta: {title: '抢购订单', type:'c', permission: 'project_orderSnapup'},
				name: 'project_orderSnapup'
			},
			{
				path: "/project/orderSnapupDetail",
				component: () => import('../../../pages/project/OrderSnapupDetail.vue'),
				meta: {title: '抢购订单详情', type:'c', permission: 'project_orderSnapup_detail'},
				name: 'project_orderSnapup_detail'
			},*/
		],
	}
];

export default router